var React = require('react');

function Circle (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"270","cy":"270","r":"269","stroke":"#D3DEF9","strokeWidth":"1","fill":"none","transform":"rotate(-90 270 270)"}));
}

Circle.defaultProps = {"viewBox":"0 0 540 540","className":"circle"};

module.exports = Circle;

Circle.default = Circle;
